///
/// EarthBrowser
///
/// Created by Matt Giger on 4/10/2024
/// Copyright (c) 2024 Geodata Labs
///

import { type Stovokor } from "@stovokor/Stovokor"

export interface FrameTask {
	id: number
	start(engine: Stovokor): void
	action(frameId: number): void
}

export class KernelFrameTask implements FrameTask {
	public id: number = 0
	private func = () => {}

	constructor(action: () => void) {
		this.func = action
	}

	public start(_engine: Stovokor): void {
	}

	public action(_frameId: number): void {
		this.func()
	}
}
